import { Card, Carousel } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { IChallengeResourceRender } from 'src/shared/models';
import { IIncludedItemsList } from 'src/shared/models/includedItems.model';
import { breakpoints, customFormatMessage, useWindowSize } from 'utils';
import { config } from 'config/config';

interface OwnProps extends IChallengeResourceRender {
  configItem: IIncludedItemsList;
}

const ChallengeIncludedItems: FC<OwnProps> = ({ configItem }) => {
  if (!config) return <React.Fragment />;

  const { items } = configItem;
  const { isSM, isMD, width } = useWindowSize();
  const carouselRef = React.useRef<any>();

  const ITEMS = '/included-items/';

  const settingsCommon = {
    bordered: false,
    autoplay: false,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
  };

  const settingsMobile = {
    ...settingsCommon,
    dots: false,
    arrows: false,
    slidesToShow: 2.5,
  };

  const settingsTablet = {
    ...settingsCommon,
    dots: { className: 'imageCarousel__dots' },
    arrows: false,
    slidesToShow: 2,
    infinite: true,
  };

  const settingsDesktop = {
    ...settingsCommon,
    dots: { className: 'imageCarousel__dots' },
    arrows: true,
    slidesToShow: 3,
  };

  const [settings, setSettings] = useState(null);

  useEffect(() => {
    if (isMD) {
      if (width > breakpoints.sm && width < breakpoints.md)
        setSettings(settingsTablet);
      else setSettings(settingsMobile);
    } else setSettings(settingsDesktop);
  }, [width]);

  const renderItemsCards = () => {
    return (
      <div className="included-items-carousel included-items-carousel-item">
        <h4 className="included-items__title">
          {customFormatMessage('experience.included-items.title')}
        </h4>
        <Carousel
          swipeToSlide
          draggable
          ref={(ref) => {
            carouselRef.current = ref;
          }}
          {...settings}
        >
          {items.map((item, i) => {
            return (
              <Card bordered key={`${i}-itemCard`}>
                <div className="included-items-section__content">
                  <div className="image-size">
                    <img
                      src={`${config.APP.ASSET_PREFIX}${ITEMS}${item.icon}.svg`}
                    />
                  </div>
                  <h3 className="included-items-section__title">
                    {item.title}
                  </h3>
                </div>
              </Card>
            );
          })}
        </Carousel>
      </div>
    );
  };

  return (
    <div className="included-items-item">
      <div className="included-items__wrapper">{renderItemsCards()}</div>
    </div>
  );
};

export default ChallengeIncludedItems;
